import { TeamForAdmin } from './team-for-admin.type';
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TeamForAdminService } from './team-for-admin.service';
import { FormControl, FormGroup } from "@angular/forms";
import { catchError, tap } from "rxjs";


@Component({
    selector: 'admin-team-settings',
    templateUrl: './admin-team-settings.component.html',
    providers: [
        forwardRef(() => TeamForAdminService)
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminTeamSettings implements OnInit {
    
    @Input()
    team: TeamForAdmin;

    @Input()
    features: string[];    

    @Output()
    onChange: EventEmitter<void> = new EventEmitter();

    protected contactCtrl: FormControl<string> = new FormControl<string>('');

    protected contactForm: FormGroup = new FormGroup({
        contact: this.contactCtrl
    })

    delete_ok: string;
    delete_errors: string;
    constructor(
        private snackBarService: SnackBarService, 
        private teamAdminService: TeamForAdminService
    ) {}

    ngOnInit() {
        this.contactCtrl.setValue(this.team.subscription.primaryContact);
    }

    copyDBQuery(teamId: string) {    
        const query = `{ id : "${teamId}" }`
        navigator.clipboard.writeText(query);
        this.snackBarService.success(`Copied ${query}`)
    }

    getFeatureToggleValue(team: TeamForAdmin, featureId: string) {
        return team.enabledFeatures.find(f => f.id === featureId)?.enabled;
    }
    
    async toggleFeature(teamId: string, featureId: string) {
        await this.teamAdminService.toggleFeature(teamId, featureId)
        this.onChange.next();
    }

    async switchToTrial(teamId: string) {
        await this.teamAdminService.switchToTrial(teamId)
        this.onChange.next();
    }

    async pushOutreachToCrm(teamId: string) {
        try {
            await this.teamAdminService.pushOutreachToCrm(teamId)
            this.snackBarService.success('Sent to CRM');
        } catch (error) {
            this.snackBarService.error(error.data);
        }
    }

    async pushRenewalToCrm(teamId: string) {
        try {
            await this.teamAdminService.pushRenewalToCrm(teamId)
            this.snackBarService.success('Sent to CRM');
        } catch (error) {
            this.snackBarService.error(error.data);
        }
    }

    async disable(teamId: string) {
        await this.teamAdminService.disable(teamId)
        this.onChange.next();
    }

    async extendsTrialPeriod(teamId: string, duration: 'week' | 'month') {
        await this.teamAdminService.extendsTrialPeriod(teamId, duration)
        this.onChange.next();
    }

    async delete(teamId: string) {
        try {
            await this.teamAdminService.delete(teamId)
            this.delete_ok = 'Team deleted';
        } catch (error) {
            this.delete_errors = error.data;
        }
    }

    updateContact(teamId: string) {
        const newContact = this.contactCtrl.getRawValue();
        if (newContact && newContact !== ''){
            this.teamAdminService.updateContact(teamId, newContact).pipe(
                catchError((err) => {
                    this.snackBarService.error(JSON.stringify(err));
                    throw err;
                }),
                tap(result => {
                    this.snackBarService.success(result);
                })
            )
            .subscribe();
        }
    }
}
